import ArticleIndex from '@components/ArticleIndex';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import type { GetStaticProps, NextPage } from 'next';

const ArticleIndexView: NextPage = () => <ArticleIndex />;

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('articleIndex');

export default ArticleIndexView;
